import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
import TuneIcon from '@mui/icons-material/Tune';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Popover } from '@mui/material';
import {Button, Checkbox, Col, DatePicker, Radio, Row, Select, Spin} from "antd";
import { parseInt } from "lodash/string";
import moment from "moment";
import { Component } from "react";
import { connect } from "react-redux";
import { get } from "../../helper/request";
import { clearAllFilters, updateTagsAndSearches } from "../../redux_actions/search.action";
import {
    caseArchiveStatusEnum,
    responsiveLayers,
    slideExportStatus,
    slideTilingStatus,
    slideUploadStatus,
    specimenType,
    scanSpeed
} from '../../utils/const';
import {isOffline, isSuperuser, isTrue, notNull} from "../../utils/utils";
import {performAbortControllerTagAndSlideSearch} from "../../utils/api";


const Option = Select.Option;
var today = new Date();
var dd = today.getDate();
const {RangePicker} = DatePicker;

let SPECIMEN = {
    'PAP': specimenType.PAP,
    'HNE TISSUE': specimenType.HNE_TISSUE,
    'IHC': specimenType.IHC,
    'BLOOD': specimenType.BLOOD,
    'BM' : specimenType.BM,
}

let SCAN_SPEED = {
    'FAST': scanSpeed.FAST,
    'MEDIUM': scanSpeed.MEDIUM,
    'SLOW': scanSpeed.SLOW,
    'ZSTACK': scanSpeed.ZSTACK,
}

class SearchBar extends Component {
    constructor(props) {
        super(props);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleDeviceChange = this.handleDeviceChange.bind(this);
        this.handleDateRangeChange = this.handleDateRangeChange.bind(this);
        this.handleExportStatus = this.handleExportStatus.bind(this);
        this.handleUploadStatus = this.handleUploadStatus.bind(this);
        this.handleTilingStatus = this.handleTilingStatus.bind(this);
        this.handleSpecimenType = this.handleSpecimenType.bind(this);
        this.handleScanSpeed = this.handleScanSpeed.bind(this);
        this.state = {
            tag_suggestions: [],
            upload_flag: "",
            export_flag: "",
            device_flag: "",
            tiling_flag: "",
            archive_flag: "",
            specimen_flag: "",
            scanSpeed_flag: "",
            date_flag: null,
            starred: false,
            case_assigned: false,
            filter: false,
            showConfirm: false,
            anchorEl: null,
            openDialog: false,
            searchbarWidth: -1,
            loadingSearchResults: false,
        };
        this.isMobile = document.documentElement.clientWidth <= responsiveLayers.MOBILE_WIDTH_LEVEL &&
            (document.documentElement.clientWidth < document.documentElement.clientHeight);
        this.is_superuser = isSuperuser()
    }

    handleTabClose = () => {
        this.setState({
            anchorEl: null
        });
        var star_flag = false, case_flag = false, exp_flag = false, up_flag = false, tile_flag = false,
            dev_flag = false, date_flag = false, archive_flag = false, spec_flag = false, speed_flag = false;
        var export_status = this.getValueByName("Export");
        var upload_status = this.getValueByName("Upload");
        var tiling_status = this.getValueByName("Tiling");
        var archive_status = this.getValueByName("Archive");
        var device_name = this.getValueByName("Device");
        var date = this.getValueByName("Date");
        var specimen_type = this.getValueByName("Specimen");
        var scanSpeed_type = this.getValueByName("ScanSpeed")
        var date_gte, date_lte;
        if (date !== null) {
            date_gte = date.split('/')[0];
            date_lte = date.split('/')[1];
        }
        if ((this.props.urlState.filters.includes("_Starred") && this.state.starred === false) || (this.props.urlState.filters.includes("_Starred") === false && this.state.starred)) {
            star_flag = true;
        }
        if ((this.props.urlState.filters.includes("_Case not assigned") && this.state.case_assigned === false) || (this.props.urlState.filters.includes("_Case not assigned") === false && this.state.case_assigned)) {
            case_flag = true;
        }
        if ((export_status !== null && (this.state.export_flag !== slideExportStatus[export_status])) || (export_status === null && this.state.export_flag !== "")) {
            exp_flag = true;
        }
        if ((upload_status !== null && (this.state.upload_flag !== slideUploadStatus[upload_status])) || (upload_status === null && this.state.upload_flag !== "")) {
            up_flag = true;
        }
        if ((tiling_status !== null && (this.state.tiling_flag !== slideTilingStatus[tiling_status])) || (tiling_status === null && this.state.tiling_flag !== "")) {
            tile_flag = true;
        }
        if ((archive_status !== null && (this.state.archive_flag !== archive_status)) || (archive_status === null && this.state.archive_flag !== "")) {
            archive_flag = true;
        }
        if ((device_name !== null && (this.state.device_flag !== parseInt(device_name))) || (device_name === null && this.state.device_flag !== "")) {
            dev_flag = true;
        }
        if ((date !== null && (this.state.date_flag.length === 0 ? true : (this.state.date_flag[0].format("YYYY-MM-DD") !== date_gte || this.state.date_flag[1].format("YYYY-MM-DD") !== date_lte))) || (date === null && this.state.date_flag !== null)) {
            date_flag = true;
        }
        if ((specimen_type !== null && (this.state.specimen_flag !== specimenType[specimen_type])) || (specimen_type === null && this.state.specimen_flag != "")) {
            spec_flag = true;
        }
        if ((scanSpeed_type !== null && (this.state.scanSpeed_flag !== scanSpeed[scanSpeed_type])) || (scanSpeed_type === null && this.state.scanSpeed_flag != "")) {
            speed_flag = true;
        }
        if (exp_flag || up_flag || tile_flag || dev_flag || star_flag || case_flag || date_flag || archive_flag || spec_flag || speed_flag) {
            this.setState({showConfirm: true, openDialog: true});
        }
    }

    getValueByName = (type) => {
        if (this.getIndexFilter(this.props.urlState.filters, type) !== -1) {
            var status = this.props.urlState.filters[this.getIndexFilter(this.props.urlState.filters, type)].split('= ')[1];
            return status;
        }
        return null;
    }

    handleToClose = () => {
        this.setState({openDialog: false});
        var export_status = this.getValueByName("Export");
        var upload_status = this.getValueByName("Upload");
        var tiling_status = this.getValueByName("Tiling");
        var archive_status = this.getValueByName("Archive");
        var device_name = this.getValueByName("Device");
        var date = this.getValueByName("Date");
        var specimen_type = this.getValueByName("Specimen");
        var scanSpeed_type = this.getValueByName("ScanSpeed")
        var date_gte, date_lte;
        if (date !== null) {
            date_gte = date.split('/')[0];
            date_lte = date.split('/')[1];
        }
        if (export_status !== null && (this.state.export_flag !== slideExportStatus[export_status])) {
            this.setState({export_flag: slideExportStatus[export_status]});
        } else if (export_status === null) {
            this.setState({export_flag: ""});
        }
        if (upload_status !== null && (this.state.upload_flag !== slideUploadStatus[upload_status])) {
            this.setState({upload_flag: slideUploadStatus[upload_status]});
        } else if (upload_status === null) {
            this.setState({upload_flag: ""});
        }
        if (archive_status !== null && (this.state.archive_flag !== archive_status)) {
            this.setState({archive_flag: archive_status});
        } else if (archive_status === null) {
            this.setState({archive_flag: ""});
        }
        if (tiling_status !== null && (this.state.tiling_flag !== slideTilingStatus[tiling_status])) {
            this.setState({tiling_flag: slideTilingStatus[tiling_status]});
        } else if (tiling_status === null) {
            this.setState({tiling_flag: ""});
        }
        if (device_name !== null && (this.state.device_flag !== parseInt(device_name))) {
            this.setState({device_flag: parseInt(device_name)});
        } else if (device_name === null) {
            this.setState({device_flag: ""});
        }
        if (date !== null && (this.state.date_flag.length !== 0 ? (moment(this.state.date_flag[0]._d, "YYYY-MM-DD") !== date_gte || moment(this.state.date_flag[1]._d, "YYYY-MM-DD") !== date_lte) : true)) {
            this.setState({date_flag: [moment(date_gte, "YYYY-MM-DD"), moment(date_lte, "YYYY-MM-DD")]});
        } else if (date === null) {
            this.setState({date_flag: null});
        }
        if ((this.props.urlState.filters.includes("_Starred") && this.state.starred === false)) {
            this.setState({starred: true});
        } else if (this.props.urlState.filters.includes("_Starred") === false && this.state.starred) {
            this.setState({starred: false});
        }
        if ((this.props.urlState.filters.includes("_Case not assigned") && this.state.case_assigned === false)) {
            this.setState({case_assigned: true});
        } else if (this.props.urlState.filters.includes("_Case not assigned") === false && this.state.case_assigned) {
            this.setState({case_assigned: false});
        }
        if (specimen_type !== null && (this.state.specimen_flag !== specimenType[specimen_type])) {
            this.setState({specimen_flag: specimenType[specimen_type]});
        } else if (specimen_type === null) {
            this.setState({specimen_flag: ""});
        }
        if (scanSpeed_type !== null && (this.state.scanSpeed_flag !== scanSpeed[scanSpeed_type])) {
            this.setState({scanSpeed_flag: scanSpeed[scanSpeed_type]});
        } else if (scanSpeed_type === null) {
            this.setState({scanSpeed_flag: ""});
        }
    }

    helper_func = (filters, type) => {
        for (let i = 0; i < filters.length; i++) {
            if (filters[i].includes(type)) {
                filters.splice(i, 1);
                break;
            }
        }
    }

    updatePane = () => {
        let count = 0;
        let filters_arr = this.props.urlState.filters;
        // test code
        var export_status = this.getValueByName("Export");
        var upload_status = this.getValueByName("Upload");
        var tiling_status = this.getValueByName("Tiling");
        var archive_status = this.getValueByName("Archive");
        var device_name = this.getValueByName("Device");
        var date = this.getValueByName("Date");
        var specimen_type = this.getValueByName("Specimen");
        var scanSpeed_type = this.getValueByName("ScanSpeed")
        var date_gte, date_lte;
        if (date !== null) {
            date_gte = date.split('/')[0];
            date_lte = date.split('/')[1];
        }

        if (this.state.upload_flag !== "") {
            if ((upload_status !== null && this.state.upload_flag !== slideUploadStatus[upload_status]) || (upload_status === null && this.state.upload_flag !== "")) {
                this.helper_func(filters_arr, 'Upload');
                filters_arr.push('Upload = ' + this.getObjectKey(slideUploadStatus, this.state.upload_flag));
                count += 1;
            }
        } else {
            if (upload_status !== null) {
                this.helper_func(filters_arr, 'Upload');
                count += 1;
            }
        }
        if (this.state.archive_flag !== "") {
            if ((archive_status !== null && this.state.archive_flag !== archive_status) || (archive_status === null && this.state.archive_flag !== "")) {
                this.helper_func(filters_arr, 'Archive');
                const display_name = isTrue(this.state.archive_flag) ? this.state.archive_flag : 'ALL';
                filters_arr.push('Archive = ' + display_name);
                count += 1;
            }
        } else {
            if (archive_status !== null) {
                this.helper_func(filters_arr, 'Archive');
                count += 1;
            }
        }
        if (this.state.export_flag !== "") {
            if ((export_status !== null && this.state.export_flag !== slideExportStatus[export_status]) || (export_status === null && this.state.export_flag !== "")) {
                this.helper_func(filters_arr, 'Export');
                filters_arr.push('Export = ' + this.getObjectKey(slideExportStatus, this.state.export_flag));
                count += 1;
            }
        } else {
            if (export_status !== null) {
                this.helper_func(filters_arr, 'Export');
                count += 1;
            }
        }
        if (this.is_superuser) {
            if (this.state.tiling_flag !== "") {
                if ((tiling_status !== null && this.state.tiling_flag !== slideTilingStatus[tiling_status]) || (tiling_status === null && this.state.tiling_flag !== "")) {
                    this.helper_func(filters_arr, 'Tiling');
                    filters_arr.push('Tiling = ' + this.getObjectKey(slideTilingStatus, this.state.tiling_flag));
                    count += 1;
                }
            } else {
                if (tiling_status !== null) {
                    this.helper_func(filters_arr, 'Tiling');
                    count += 1;
                }
            }
        }
        if (this.state.device_flag !== "") {
            if ((device_name !== null && this.state.device_flag !== parseInt(device_name)) || (device_name === null && this.state.device_flag !== "")) {
                this.helper_func(filters_arr, 'Device');
                filters_arr.push('Device = ' + parseInt(this.state.device_flag));
                count += 1;
            }
        } else {
            if (device_name !== null) {
                this.helper_func(filters_arr, 'Device');
                count += 1;
            }
        }
        if (this.state.starred === true) {
            if (!filters_arr.includes('_Starred')) {
                filters_arr.push('_Starred');
                count += 1;
            }
        } else {
            if (filters_arr.includes('_Starred')) {
                this.helper_func(filters_arr, '_Starred');
                count += 1;
            }
        }
        if (this.state.case_assigned === true) {
            if (!filters_arr.includes('_Case not assigned')) {
                filters_arr.push('_Case not assigned');
                count += 1;
            }
        } else {
            if (filters_arr.includes('_Case not assigned')) {
                this.helper_func(filters_arr, '_Case not assigned')
                count += 1;
            }
        }
        if (this.state.date_flag !== null && this.state.date_flag.length !== 0) {
            if ((date !== null && (moment(this.state.date_flag[0]._d, "YYYY-MM-DD") !== date_gte || moment(this.state.date_flag[1]._d, "YYYY-MM-DD") !== date_lte)) || (date === null && this.state.date_flag !== null)) {
                this.helper_func(filters_arr, 'Date');
                filters_arr.push(('Date = ' + this.state.date_flag[0].format("YYYY-MM-DD")) + ("/") + (this.state.date_flag[1].format("YYYY-MM-DD")));
                count += 1;
            }
        } else {
            this.helper_func(filters_arr, 'Date');
            count += 1;
        }
        if (this.state.specimen_flag !== "") {
            if ((specimen_type !== null && this.state.specimen_flag !== specimenType[specimen_type]) || (specimen_type === null && this.state.specimen_flag !== "")) {
                this.helper_func(filters_arr, 'Specimen');
                filters_arr.push('Specimen = ' + this.getObjectKey(specimenType, this.state.specimen_flag));
                count += 1;
            }
        } else {
            if (specimen_type !== null) {
                this.helper_func(filters_arr, 'Specimen');
                count += 1;
            }
        }
        if (this.state.scanSpeed_flag !== "") {
            if ((scanSpeed_type !== null && this.state.scanSpeed_flag !== scanSpeed[scanSpeed_type]) || (scanSpeed_type === null && this.state.scanSpeed_flag !== "")) {
                this.helper_func(filters_arr, 'ScanSpeed');
                filters_arr.push('ScanSpeed = ' + this.getObjectKey(scanSpeed, this.state.scanSpeed_flag));
                count += 1;
            }
        } else {
            if (scanSpeed_type !== null) {
                this.helper_func(filters_arr, 'ScanSpeed');
                count += 1;
            }
        }

        if (count >= 1) {
            try {
                this.props.dispatch(updateTagsAndSearches(this.props.urlState.tags, this.props.urlState.searches, filters_arr, this.props.urlState));
                this.setState({filter: true});
            } catch {
                this.props.dispatch(updateTagsAndSearches(this.props.urlState.tags, this.props.urlState.searches, filters_arr, this.props.urlState));
                this.setState({filter: true});
            }
        }
        this.setState({
            upload_flag: this.state.upload_flag,
            export_flag: this.state.export_flag,
            device_flag: this.state.device_flag,
            tiling_flag: this.state.tiling_flag,
            archive_flag: this.state.archive_flag,
            specimen_flag: this.state.specimen_flag,
            scanSpeed_flag: this.state.scanSpeed_flag,
            anchorEl: null,
            openDialog: false
        });
    }

    componentDidMount() {
        var export_status = this.getValueByName("Export");
        var upload_status = this.getValueByName("Upload");
        var tiling_status = this.getValueByName("Tiling");
        var archive_status = this.getValueByName("Archive");
        var device_name = this.getValueByName("Device");
        var date = this.getValueByName("Date");
        var specimen_type = this.getValueByName("Specimen");
        var scanSpeed_type = this.getValueByName("ScanSpeed")
        var date_gte, date_lte;
        if (date !== null) {
            date_gte = date.split('/')[0];
            date_lte = date.split('/')[1];
        }
        if ((this.props.urlState.filters.includes("_Starred") && this.state.starred === false)) {
            this.setState({starred: true});
        }
        if ((this.props.urlState.filters.includes("_Case not assigned") && this.state.case_assigned === false)) {
            this.setState({case_assigned: true});
        }
        if (export_status !== null) {
            this.setState({export_flag: slideExportStatus[export_status]});
        }
        if (upload_status !== null) {
            this.setState({upload_flag: slideUploadStatus[upload_status]});
        }
        if (tiling_status !== null) {
            this.setState({tiling_flag: slideTilingStatus[tiling_status]});
        }
        if (archive_status !== null) {
            this.setState({archive_flag: archive_status});
        }
        if (device_name !== null) {
            this.setState({device_flag: parseInt(device_name)});
        }
        if (date !== null) {
            this.setState({date_flag: [moment(date_gte, "YYYY-MM-DD"), moment(date_lte, "YYYY-MM-DD")]});
        }
        if (specimen_type !== null) {
            this.setState({specimen_flag: specimenType[specimen_type]});
        }
        if (scanSpeed_type !== null) {
            this.setState({scanSpeed_flag: scanSpeed[scanSpeed_type]});
        }
    }

    searchBarWidthChange = () => {
        const searchBar = document.getElementById("search-bar");
        this.setState({searchBarWidth: notNull(searchBar?.offsetWidth) ? searchBar.offsetWidth - 10 : -1})
    }

    handleDeviceChange(value) {
        this.setState({device_flag: value});
    }

    handleDateRangeChange(moment) {
        this.setState({date_flag: moment});
    }

    handleTypeChange() {
        let star = document.getElementById('star');
        let case1 = document.getElementById('case');
        if (star.checked) {
            document.getElementById('star').checked = true;
            this.setState({starred: true});
        } else {
            document.getElementById('star').checked = false;
            this.setState({starred: false});
        }
        if (case1.checked) {
            this.setState({case_assigned: true});
        } else {
            this.setState({case_assigned: false});
        }
        if (!star.checked && !case1.checked) {
            this.setState({starred: false, case_assigned: false, invalid: false});
        }
    }

    handleExportStatus(value) {
        this.setState({export_flag: value});
    }

    handleUploadStatus(value) {
        this.setState({upload_flag: value});
    }

    handleArchiveStatus(value) {
        this.setState({archive_flag: value});
    }

    handleTilingStatus(value) {
        this.setState({tiling_flag: value});
    }

    handleSpecimenType(value) {
        this.setState({specimen_flag: value});
    }

    handleScanSpeed(value) {
        this.setState({scanSpeed_flag: value});
    }

    updateSearchResults = (searchResults) => {
        this.setState({
            loadingSearchResults: false,
            tag_suggestions: searchResults,
        })
    }

    performSearch = (value) => {
        this.setState({
            loadingSearchResults: true
        })
        performAbortControllerTagAndSlideSearch(value,this.updateSearchResults)
    }

    handleTabChange = (event) => {
        this.searchBarWidthChange();
        this.setState({
            openDialog: false,
            anchorEl: event.currentTarget,
        });
    }

    getIndexFilter = (filter, type) => {
        var value = -1;
        for (let i = 0; i < filter.length; i++) {
            if ((filter[i].indexOf(type)) !== -1) {
                value = i;
            }
        }
        return value;
    }

    getApplyPane = () => {
        this.setState({openDialog: false});
        document.getElementById('openPane').click();
    }

    getStarBox = () => {
        return (
            <Checkbox id='star'
                      checked={this.state.starred === true ? "checked" : ""}
                      onClick={this.handleTypeChange} style={{fontSize: '15px'}}>Starred</Checkbox>
        )
    }

    getCaseBox = () => {
        return (
            <Checkbox id='case' checked={this.state.case_assigned === true ? "checked" : ""}
            onClick={this.handleTypeChange} style={{fontSize: '15px'}}>Folder not Assigned</Checkbox>
        )
    }

    getFilterpane = () => {

        if (this.state.searchBarWidth === -1) return null;

        let device_options = [
            <Option value={""}>
                All
            </Option>
        ]
        if (this.props.devices.length > 0) {
            for (let i = 0; i < this.props.devices.length; i++) {
                device_options.push(
                    <Option value={this.props.devices[i].id}>
                        {this.props.devices[i].name}
                    </Option>
                )
            }
        }

        const scanSpeedOptions = Object.entries(SCAN_SPEED).map(([label, value  ]) => (
            <Option value={value}>{label}</Option>
        ));

        const specimenOptions = Object.entries(SPECIMEN).map(([label, value]) => (
            <Option value={value}>{label}</Option>
        ));

        return (
                <div>
				<Popover open={!!this.state.anchorEl} anchorEl={this.state.anchorEl} onClose={this.handleTabClose}
						 anchorOrigin={{vertical: 'bottom', horizontal: 'right',}} transformOrigin={{vertical: 'top', horizontal: 'right',}}
						 sx = {{zIndex: 10, left:'5px'}}
				>
					<div id="filter_pane" style={{height: this.is_superuser ?
    							(this.state.searchBarWidth<580?'560px':'480px'): (this.state.searchBarWidth<580?'510px':'425px'),
						paddingLeft: this.state.searchBarWidth<580?'12%':'6%', paddingTop: '12px', display:"flex", flexDirection:"column", background: 'white',
						width: `${this.state.searchBarWidth+9}px`, borderColor: '#d9d9d9', alignItems: this.state.searchBarWidth<580?"center":"left"}}>
                        {/*new row styling*/}
                        <Row>
                            <Col sm={this.state.searchBarWidth < 580 ? 22 : 15}>
                                <Row>
                                    <b><h3>Filters</h3></b>
                                </Row>
                                <Row style={{width: '100%'}}>
                                    <label>Date Range : </label>
                                    <RangePicker
                                        dateRender={current => {
                                            const style = {};
                                            if (current.date() === dd) {
                                                style.backgroundColor = "transparent";
                                                style.color = "black";
                                            }
                                            return (
                                                <div className="ant-calendar-date" style={style}>
                                                    {current.date()}
                                                </div>
                                            );
                                        }}
                                        showToday
                                        onChange={this.handleDateRangeChange}
                                        value={(this.state.date_flag === null || this.state.date_flag.length === 0) ? undefined : [moment(this.state.date_flag[0]._d, "YYYY-MM-DD"), moment(this.state.date_flag[1]._d, "YYYY-MM-DD")]}
                                        format="YYYY-MM-DD"
                                        defaultValue={[undefined, undefined]}
                                        style={{width: '65%', marginLeft: 29}}
                                    />
                                    <br/><br/>
                                </Row>
                                {isOffline() ?
                                <Row style={{width: '100%'}}>
                                    <label>Select Device : </label>
                                    <Select
                                        value={this.state.device_flag === "" ? undefined : this.state.device_flag}
                                        placeholder="Filter Devices"
                                        onChange={this.handleDeviceChange}
                                        style={{width: '65%', marginLeft: 18}}
                                        id="device_change"
                                    >
                                        {device_options}
                                    </Select>
                                    <br/><br/>
                                </Row> : null}
                                <Row style={{width: '100%'}}>
                                    <label>Export Status : </label>
                                    <Select
                                        value={this.state.export_flag === "" ? undefined : this.state.export_flag}
                                        placeholder="Export Status"
                                        onChange={this.handleExportStatus}
                                        style={{width: '65%', marginLeft: 17}}
                                        id="export_status"
                                    >
                                        <Option value="">All</Option>
                                        <Option value={slideExportStatus.DONE}>Export Done</Option>
                                        <Option value={slideExportStatus.IN_PROGRESS}>InProgress</Option>
                                        <Option value={slideExportStatus.QUEUED}>Queued</Option>
                                        <Option value={slideExportStatus.QUEUED_PRIORITY}>Queued Priority</Option>
                                        <Option value={slideExportStatus.NOT_DONE}>Not Done</Option>
                                        <Option value={slideExportStatus.ERROR}>Error</Option>
                                    </Select>
                                    <br/><br/>
                                </Row>
                                <Row style={{width: '100%'}}>
                                    <label>Upload Status : </label>
                                    <Select
                                        value={this.state.upload_flag === "" ? undefined : this.state.upload_flag}
                                        placeholder="Upload Status"
                                        onChange={this.handleUploadStatus}
                                        style={{width: '65%', marginLeft: 14}}
                                        id="upload_status"
                                    >
                                        <Option value="">All</Option>
                                        <Option value={slideUploadStatus.DONE}>Upload Done</Option>
                                        <Option value={slideUploadStatus.NOT_STARTED}>Not Started</Option>
                                        <Option value={slideUploadStatus.IN_PROGRESS}>InProgress</Option>
                                        <Option value={slideUploadStatus.ERROR}>Error</Option>
                                    </Select>
                                    <br/><br/>
                                </Row>
                                <Row style={{width: '100%'}}>
                                    <label>Specimen Type : </label>
                                    <Select
                                        value={this.state.specimen_flag === "" ? undefined : this.state.specimen_flag}
                                        placeholder="Specimen Type"
                                        onChange={this.handleSpecimenType}
                                        style={{width: '65%', marginLeft: 8}}
                                        id="specimen_type"
                                    >
                                        <Option value="">All</Option>
                                        {specimenOptions}
                                    </Select>
                                    <br/><br/>
                                </Row>
                                <Row style={{width: '100%'}}>
                                    <label>Scan Speed : </label>
                                    <Select
                                        value={this.state.scanSpeed_flag === "" ? undefined : this.state.scanSpeed_flag}
                                        placeholder="Scan Speed"
                                        onChange={this.handleScanSpeed}
                                        style={{width: '65%', marginLeft: 31}}
                                        id="scanSpeed_type"
                                    >
                                        <Option value="">All</Option>
                                        {scanSpeedOptions}
                                    </Select>
                                    <br/><br/>
                                </Row>
                                {/*unarchived will give all, archived will give only archived, all will give only unarchived*/}
                                <Row style={{width: '100%'}}>
                                    <label>Archive Status : </label>
                                    <Radio.Group value={this.state.archive_flag} onChange={(e) => {
                                        e.stopPropagation();
                                        this.handleArchiveStatus(e.target.value)
                                    }}
                                        // className={"purple-radio-group"}
                                                 id="archive_status"
                                                 style={{marginLeft: 13}}>
                                        <Radio.Button value={caseArchiveStatusEnum.ALL}>
                                            Inbox
                                        </Radio.Button>
                                        <Radio.Button value={caseArchiveStatusEnum.ARCHIVED}>
                                            Archived
                                        </Radio.Button>
                                        <Radio.Button value={caseArchiveStatusEnum.UNARCHIVED}>
                                            All
                                        </Radio.Button>
                                    </Radio.Group>
                                    <br/>
                                    {this.is_superuser ? <br/> : null}
                                </Row>
                                {this.is_superuser ?
                                    <Row style={{width: '100%'}}>
                                        <label>Tiling Status : </label>
                                        <Select
                                            value={this.state.tiling_flag === "" ? undefined : this.state.tiling_flag}
                                            placeholder="Tiling Status"
                                            onChange={this.handleTilingStatus}
                                            style={{width: '65%', marginLeft: 25}}
                                        >
                                            <Option value={""}>All</Option>
                                            <Option value={slideTilingStatus.TILING_DONE}>Tiling Done</Option>
                                            <Option value={slideTilingStatus.TILING_NOT_DONE}>Not Done</Option>
                                            <Option value={slideTilingStatus.TILING_IN_PROGRESS}>InProgress</Option>
                                            <Option value={slideTilingStatus.TILING_ERRORED_OUT}>Error</Option>
                                        </Select>
                                        <br/>
                                        {this.state.searchBarWidth >= 580 ? <br/> : undefined}
                                    </Row>
                                    : undefined}
                                {this.state.searchBarWidth < 580 ?
                                    <>
                                        <Row style={{float: "left", width: '100%'}}>
                                            <br/>
                                            {this.getStarBox()}
                                            {this.getCaseBox()}
                                            <br/><br/>
                                        </Row>
                                        <Row style={{width: "100%"}}>
                                            <div style={{float: "right"}}>
                                                <Button type="secondary" onClick={this.clearSearch}
                                                        style={{marginLeft: '0px'}}>Clear</Button>
                                                <Button type="primary" onClick={this.updatePane}
                                                        style={{marginLeft: '12px'}}>Apply</Button>
                                            </div>
                                        </Row>
                                    </>
                                    : undefined}
                            </Col>
                            {this.state.searchBarWidth >= 580 ?
                                <Col sm={9}>
                                    <Row style={{height: '40px'}}>
                                    </Row>
                                    <Row style={{width: '100%'}}>
                                        {this.getStarBox()}
                                    </Row>
                                    <Row style={{marginTop: 30, width: '100%'}}>
                                        {this.getCaseBox()}
                                    </Row>
                                    <Row style={{height: this.is_superuser ? '182px' : '130px'}}>
                                    </Row>
                                    <Row style={{width: "76%", paddingBottom: "15px", marginTop: '106px'        }}> 
                                        <div style={{float: "right"}}>
                                            <Button type="secondary" onClick={this.clearSearch}
                                                    style={{marginLeft: '0px'}}>Clear</Button>
                                            <Button type="primary" onClick={this.updatePane}
                                                    style={{marginLeft: '12px'}}>Apply</Button>
                                        </div>
                                    </Row>
                                </Col>
                                : undefined}
                        </Row>
                    </div>
                </Popover>
            </div>
        )
    }

    getConfirmBox = () => {
        return (
            <>
                <Dialog open={this.state.openDialog} onClose={this.handleToClose}>
                    <DialogTitle style={{
                        backgroundColor: 'rgb(58, 34,68)',
                        color: 'white'
                    }}>{"Apply selected filters!"}</DialogTitle>
                    <DialogContent style={{marginTop: '15px'}}>
                        <DialogContentText>
                            Some filters have not been applied, click to review
                            <br/>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleToClose}
                                style={{color: 'red'}}>
                            Discard
                        </Button>
                        <Button onClick={this.getApplyPane}
                                color="primary" autoFocus>
                            Review
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }

    clearSearch = () => {
        this.setState({
            upload_flag: "", export_flag: "", device_flag: "", tiling_flag: "", specimen_flag: "", scanSpeed_flag: "",
            date_flag: null, starred: false, case_assigned: false, filter: false, anchorEl: null
        });
        this.props.dispatch(clearAllFilters());
    }

    updateUrlState = (values) => {
        var tags = [];
        var searches = [];
        var filters = [];
        values.forEach((value) => {
            if (value.startsWith('#') && value.length > 1) {
                tags.push(value);
            } else if (value.startsWith('_') || value.includes('=')) {
                if (value.includes('Device')) {
                    var device = value.split("= ")[1]
                    for (let i = 0; i < this.props.devices.length; i++) {
                        if (this.props.devices[i].name.toString === device.toString) {
                            filters.push('Device = ' + this.props.devices[i].id);
                            break;
                        }
                    }
                } else {
                    filters.push(value);
                }
            } else {
                searches.push(value);
            }
        });
        if (filters.length !== 0) {
            var exp, upload, device, tile, star, case1, date, specimen, scanspeed;
            exp = upload = device = tile = star = case1 = date = specimen = scanspeed = false;
            filters.forEach((value) => {
                if (value.includes('Export') === true) {
                    exp = true;
                }
                if (value.includes('Upload') === true) {
                    upload = true;
                }
                if (value.includes('Tiling') === true) {
                    tile = true;
                }
                if (value.includes('Device') === true) {
                    device = true;
                }
                if (value.includes('_Starred') === true) {
                    star = true;
                }
                if (value.includes('_Case') === true) {
                    case1 = true;
                }
                if (value.includes("Date")) {
                    date = true;
                }
                if (value.includes("Specimen")) {
                    specimen = true;
                }
                if (value.includes("ScanSpeed")) {
                    scanspeed = true;
                }
            })
            if (exp === false) {
                this.setState({export_flag: ""});
            }
            if (upload === false) {
                this.setState({upload_flag: ""});
            }
            if (device === false) {
                this.setState({device_flag: ""});
            }
            if (tile === false) {
                this.setState({tiling_flag: ""});
            }
            if (specimen === false) {
                this.setState({specimen_flag: ""});
            }
            if (scanspeed === false) {
                this.setState({scanSpeed_flag: ""});
            }
            if (star === false) {
                this.setState({starred: false});
            }
            if (case1 === false) {
                this.setState({case_assigned: false});
            }
            if (!date) {
                this.setState({date_flag: null});
            }
        } else {
            this.setState({
                export_flag: "",
                upload_flag: "",
                device_flag: "",
                tiling_flag: "",
                specimen_flag: "",
                scanSpeed_flag: "",
                starred: false,
                case_assigned: false,
                date_flag: null
            });
        }
        this.props.dispatch(updateTagsAndSearches(tags, searches, filters, this.props.urlState));
    }

    handleChange = (values) => {
        this.setState({
            tag_suggestions: []
        });
        this.updateUrlState(values);
    }

    getObjectKey(obj, value) {
        if (Object.keys(obj).find(key => obj[key] === value)) {
            return Object.keys(obj).find(key => obj[key] === value);
        } else {
            return null;
        }
    }

    render() {

        let selected = [];

        selected.push(...this.props.urlState.tags);
        selected.push(...this.props.urlState.searches);
        selected.push(...this.props.urlState.filters);

        let device_name = ""

        this.props.urlState.filters.forEach(filter => {
            if (filter.includes("Device")) {
                const device_id = filter.split("= ")[1]

                for (let i = 0; i < this.props.devices.length; i++) {
                    if (parseInt(this.props.devices[i].id) === parseInt(device_id)) {
                        device_name = this.props.devices[i].name;
                        break;
                    }
                }
            }
        })

        if (device_name !== "") {
            selected.forEach(individual => {
                if (individual.includes('Device')) {
                    var index = selected.indexOf(individual);
                    selected.splice(index, 1, 'Device = ' + device_name);
                }
            })
        }

        let numSuggested = this.state.tag_suggestions.length;

        let tagSuggestionsBox = numSuggested > 0 || this.state.loadingSearchResults ?
            <Select.OptGroup label={this.state.loadingSearchResults ?  <div><Spin size="small"/> <span style={{marginLeft: 5}}>{" Loading Results... "}</span></div> :
                <div><b>{numSuggested}</b> result{numSuggested > 1 ? 's' : ''} found </div>}>
                {this.state.tag_suggestions.map((item, index) => (
                    <Select.Option
                        key={index}
                        value={item.display_text}
                        label={item.display_text}
                        className='search-result-tag'
                        size='small'
                        type='tag'
                    >
                        <span className={'preserve-white-space'}>{item.display_text}</span><span style={{float: "right", fontSize: 12}}></span>
                    </Select.Option>
                ))}
            </Select.OptGroup> : undefined;

        return (
            <div>
                <div id={'dashboard-search-select'} className={'custom-dropdown-max-height'} style={{display: "flex", marginLeft: -100}}>
                    <Select
                        showSearch
                        // allowClear
                        id="search-bar"
                        className="search-input"
                        placeholder={<div><SearchOutlined></SearchOutlined> Search by Name
                            or {this.isMobile ? "# Tag" : "Tag (begin tag search with #)"} </div>}
                        showArrow={false}
                        filterOption={false}
                        notFoundContent={null}
                        onSearch={this.performSearch}
                        mode="tags"
                        onChange={this.handleChange}
                        optionLabelProp="label"
                        value={selected}
                        popupClassName={"bask-mc"}
                        getPopupContainer={() => document.getElementById('dashboard-search-select')}
                        style={{
                            width: '890px',
                            marginRight: !(this.props.urlState.filters.length !== 0 || this.props.urlState.tags.length !== 0 || this.props.urlState.searches.length !== 0) ? '-30px' : '-82px'
                        }}
                    >
                        {tagSuggestionsBox}
                    </Select>
                    <Button style={{
                        visibility: !this.isMobile ? 'visible' : 'hidden',
                        border: 0,
                        fontSize: 20
                    }}
                            type="danger"
                            ghost
                            size="medium"

                            hidden={(!(this.props.urlState.filters.length !== 0 || this.props.urlState.tags.length !== 0 || this.props.urlState.searches.length !== 0))}
                            onClick={this.clearSearch}><CloseCircleOutlined/></Button>
                    <Button id="openPane" style={{
                        background: 'transparent',
                        border: 0,
                        top: '1.5px',
                        padding: 0,
                        margin: 0,
                        visibility: !this.isMobile ? 'visible' : 'hidden'
                    }} title="Search options" onClick={this.handleTabChange}><TuneIcon/></Button>
                </div>
                {this.getFilterpane()}
                {this.state.showConfirm &&
                    this.getConfirmBox()
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isFetching: state.searchReducer.isFetching,
        urlState: state.searchReducer,
        morpheusSetting: state.morpheusSettingReducer,
    };
};

export default connect(mapStateToProps)(SearchBar);